import type { DataSource, PhotoSwipeOptions, SlideData } from 'photoswipe';
import { onMounted } from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore не подтягивается модуль в ide
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/dist/photoswipe.css';

export const useMediaModal = (dataSource: SlideData[]) => {
  const options: PhotoSwipeOptions = {
    dataSource: dataSource,
    pswpModule: () => import('photoswipe'),
    bgOpacity: 0.8,
    loop: true,
    indexIndicatorSep: '/',
    showHideAnimationType: 'zoom',
    padding: { top: 50, bottom: 50, left: 100, right: 100 },
    preloaderDelay: 0.3,
    spacing: 0.5,
    closeOnVerticalDrag: false,
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
  };

  const lightbox = new PhotoSwipeLightbox(options);

  onMounted(() => {
    lightbox.init();
    lightbox.on('change', async () => {
      const currIndex = lightbox.pswp.currIndex;
      const optionsIndex = lightbox.options.index;
      if (currIndex !== optionsIndex) {
        lightbox.pswp.close();
        await new Promise((resolve) => setTimeout(resolve, 1))
        lightbox.loadAndOpen(currIndex, options.dataSource);
      }
    })

  });

  const openMediaModal = (index: number) => {
    lightbox.loadAndOpen(index, options.dataSource as DataSource);
  };

  const destroyMediaModal = () => {
    lightbox.destroy();
  };

  return {
    openMediaModal,
    destroyMediaModal,
  };
};
